import React, { useMemo } from "react";
import { displayDayTime } from "../../utils";
import { navigate } from "@reach/router";
import StatusBadge from "../common/StatusBadge";

const SingleClassRow = ({ single_class }) => {
  const activeReservations = useMemo(
    () =>
      single_class?.class_reservations?.filter(
        ({ deletedAt }) => deletedAt === null
      ).length || 0,
    [single_class]
  );

  const renderInstructors = () => {
    if (single_class.class_instructors !== null) {
      if (single_class.class_instructors.length > 0) {
        return single_class.class_instructors
          .filter(({ instructor }) => instructor !== null)
          .map(({ instructor }) => instructor?.name)
          .join(",");
      }
    }
    return "N/D";
  };

  const renderLocation = () => {
    if (single_class.location && single_class.location !== null) {
      return single_class.location.name;
    }
  };

  return (
    <tr
      className="small align-middle hover-light"
      onClick={() =>
        navigate(`/myadmin/asistentes/${single_class.single_class_id}`)
      }
    >
      <td>
        {displayDayTime(single_class.class_date)}{" "}
        {single_class.deletedAt !== null && (
          <StatusBadge status="cancelled" date={single_class.deletedAt} />
        )}
      </td>
      <td>{renderInstructors()}</td>
      <td>{renderLocation()}</td>
      <td>
        {activeReservations} / {single_class.capacity}
      </td>
    </tr>
  );
};
export default SingleClassRow;
